/**
 * theme.js
 *
 * Single source of truth for the Resido design system.
 * Ported from Android's Color.kt and Type.kt.
 *
 * All components should import from here instead of defining inline THEME objects.
 * Supports light/dark mode via CSS custom properties (see index.css).
 */

export const THEME = {
    colors: {
        // Dark mode (default) — matches Android Color.kt
        midnightBlue: '#0F172A',       // Background
        midnightSurface: '#1E293B',    // Surface / Cards
        goldAccent: '#F59E0B',         // Primary Action (CTA, highlights)
        goldContainer: '#FEF3C7',      // Gold container (light variant)
        tealAccent: '#14B8A6',         // Secondary / Success
        error: '#EF4444',              // Error / Warning
        pureWhite: '#FFFFFF',
        textPrimary: '#F8FAFC',        // Headings
        textSecondary: '#94A3B8',      // Body text
        inputBg: '#0F172A',            // Input field background
        borderColor: '#334155',        // Border / Divider
        dividerColor: '#334155',       // Alias for borderColor

        // Light mode overrides (used with CSS vars)
        light: {
            background: '#F8FAFC',
            surface: '#FFFFFF',
            textPrimary: '#0F172A',
            textSecondary: '#475569',
            inputBg: '#F1F5F9',
            borderColor: '#E2E8F0',
        }
    },
    fonts: {
        heading: "'Poppins', sans-serif",  // Matches Android Type.kt
        body: "'Inter', sans-serif",        // Matches Android Type.kt
    },
    transitions: {
        fast: '0.15s ease',
        normal: '0.3s ease',
        slow: '0.5s ease',
        spring: '0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    },
    shadows: {
        card: '0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -1px rgba(0, 0, 0, 0.2)',
        glow: {
            gold: '0 4px 14px 0 rgba(245, 158, 11, 0.25)',
            teal: '0 4px 14px 0 rgba(20, 184, 166, 0.25)',
            error: '0 4px 14px 0 rgba(239, 68, 68, 0.25)',
        },
    },
};

export default THEME;
